import { constructCompositeKey, deconstructFactKey } from './keyUtilities';
import { selectOrInit } from './selectors';

export const accumulateFactsFromDataRows = (
  headerRow,
  dataRows,
  configJson,
  documentCode
) =>
  dataRows.reduce((factsAccumulator, row) => {
    const financialPeriodHeaders = headerRow.slice(
      configJson.summableColumnStartIndex
    );
    const rowHeaders = row.slice(0, configJson.summableColumnStartIndex);
    const amounts = row.slice(configJson.summableColumnStartIndex);

    amounts.forEach((value, index) => {
      if (financialPeriodHeaders[index] !== '') {
        const key = constructCompositeKey(
          documentCode,
          rowHeaders,
          configJson.keyPositions,
          financialPeriodHeaders[index]
        );

        const { aggregator } = deconstructFactKey(key);
        const aggregatorState = selectOrInit(factsAccumulator, aggregator);
        aggregatorState[key] = value;
      }
    });
    return factsAccumulator;
  }, {});
